// Patterns that indicate a stale chunk / failed dynamic-import ("code-split") load.
// This class of error is only recoverable with a full page reload (e.g. chunk hashes
// changed after a redeploy), so it must reach the app-level AppErrorBoundary rather than
// being swallowed by a local boundary.
const CHUNK_ERROR_PATTERNS = [
  'dynamically imported module',
  'Loading chunk',
  'Failed to load module script',
]

/**
 * True when `error` looks like a stale/failed dynamic-import (code-split chunk) load.
 * Shared by `AppErrorBoundary` (which reloads the page to recover) and `SafeSubtree`
 * (which rethrows these so that app-level recovery can run instead of silently hiding
 * the subtree).
 */
export function isChunkLoadError(error: Error | null | undefined): boolean {
  const message = error?.message || ''
  return CHUNK_ERROR_PATTERNS.some((pattern) =>
    message.toLowerCase().includes(pattern.toLowerCase())
  )
}
